import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisValueGroup } from '../../model/his-value-group';

@Component( {
    selector: 'his-dynamic-container-inner',
    templateUrl: './dynamic-container-inner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDynamicContainerInnerComponent {

    @Input() dynamicFieldConfig: HisDynamicFieldConfig;

    @Input() valueGroup: HisValueGroup;
    @Input() form: UntypedFormGroup;

    /**
     * @deprecated
     * Will be deleted shortly. Use getJson instead.
     */
    etStringRepresentation(): any {
        return this.valueGroup.getJson();
    }

    getJson( ignoreEmptyValues: boolean = true ): any {
        return this.valueGroup.getJson( ignoreEmptyValues );
    }

    resetDynamicForm() {
        this.valueGroup.resetDynamicForm();
    }

    dropDynamicForms() {
        this.valueGroup.dropDynamicFields();
    }
}
